import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CommonTitleIcon from "@/assets/img/common/commonTitleIcon.png";
const ModuleHeader = ({ title, children, className = "", }) => {
    return (_jsx("div", { className: `relative w-full ${className}`, style: {
            height: "0.4rem", // 保持原有rem高度基准
            transformOrigin: "0 0",
        }, children: _jsxs("div", { className: "h-full absolute inset-0 relative overflow-hidden", style: {
                padding: 0,
                boxShadow: "inset 0 0 0 0.01rem transparent",
            }, children: [_jsx("div", { className: "absolute inset-0 z-0 flex items-center justify-center", style: {
                        height: "100%",
                        transform: "inherit",
                    }, children: _jsx("img", { src: CommonTitleIcon, alt: "\u6A21\u5757\u6807\u9898\u80CC\u666F\u56FE\u6807", className: "absolute inset-0", style: {
                            // 基于rem设置尺寸，确保与父容器比例一致
                            width: "100%", // 宽度占满父容器（父容器宽度由外部布局决定）
                            height: "100%", // 高度与父容器高度（0.4rem）一致
                            objectFit: "cover", // 保持图片比例，覆盖整个容器（避免拉伸变形）
                            objectPosition: "center", // 图片居中显示
                        }, onError: () => { } }) }), _jsxs("div", { className: "relative z-10 flex items-center", style: {
                        height: "100%",
                    }, children: [_jsx("div", { className: "flex items-center h-full flex-shrink-0", children: _jsx("span", { className: "text-white font-bold tracking-wider drop-shadow-lg whitespace-nowrap", style: {
                                    width: "1.7rem",
                                    marginLeft: "0.4rem",
                                    fontFamily: "Source Han Sans CN",
                                    fontSize: "0.16rem",
                                    lineHeight: "0.4rem",
                                    display: "inline-flex",
                                    alignItems: "center",
                                }, children: title }) }), children && (_jsx("div", { className: "flex items-center gap-[0.03rem] flex-shrink-0 ml-[0.01rem]", style: {
                                transform: "translateY(0.07rem)",
                            }, children: _jsx("div", { className: "flex items-center gap-[0.02rem] max-w-md overflow-hidden", children: children }) })), _jsx("div", { className: "flex items-center gap-[0.03rem] flex-shrink-0", children: _jsx("div", { className: "flex items-center gap-[0.02rem] max-w-md overflow-hidden" }) })] })] }) }));
};
export default ModuleHeader;
